module.exports = __webpack_public_path__ + "images/ff6c935f8f75c60774216c84b6ffb6d2-jamaicalogo.jpg";